import context from '@helpers/context'
import React, { useState } from 'react'

const [
    AppContext,
    useAppContext
] = context<Contexts.App>()

const [
    AppStateContext,
    useAppStateContext
] = context<Contexts.App.State>()

export default function AppProvider({ children }: React.PropsWithChildren<{}>) {
    const [title, setTitle] = useState<string>()
    
    return (
        <AppContext.Provider value={{ setTitle }}>
            <AppStateContext.Provider value={{ title }}>
                {children}
            </AppStateContext.Provider>
        </AppContext.Provider>
    )
}

export { useAppContext, useAppStateContext }